import { cn } from "@/src/lib/utils";
import { SquareArrowUpRightIcon } from "lucide-react";
import Link from "next/link";

export interface IWebFooterLinkGroup {
  title: string;
  links: {
    label: string;
    href: string;
  }[];
}

export const kFooterLinkGroups: IWebFooterLinkGroup[] = [
  {
    title: "Other Products",
    links: [
      { label: "fimidara", href: "https://fimidara.com" },
      { label: "fimipost", href: "https://fimipost.ywordk.com" },
      { label: "fimidx", href: "https://dx.fimidara.com" },
    ],
  },
];

export function WebFooterLinkGroup(props: {
  group: IWebFooterLinkGroup;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col gap-2", props.className)}>
      <h3 className="text-sm font-bold text-muted-foreground">
        {props.group.title}
      </h3>
      <ul className="flex list-none! flex-col gap-2 p-0!">
        {props.group.links.map((link) => (
          <li key={link.href} className="list-none">
            <Link
              href={link.href}
              className="text-muted-foreground hover:text-primary transition-colors duration-300 text-sm flex items-center gap-2"
            >
              <span>{link.label}</span>
              <SquareArrowUpRightIcon className="w-3 h-3" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
